import 'core-js/stable'
import 'regenerator-runtime/runtime'
import './utils/directives'
import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import Element from 'element-ui'
import { Message } from '@/utils/Message'
import './styles/element-variables.scss'
import './permission' // permission control
import './preprocess' // 预处理

// 缩略图预览
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import 'ag-grid-community/dist/styles/ag-grid.min.css'
import 'ag-grid-community/dist/styles/ag-theme-balham.min.css'
import '@/styles/cargo.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import i18n from './lang' // Internationalization
import './icons' // icon
import './utils/errorLog' // error log
import numeral from 'numeral' // number format
import moment from 'moment' // date format

import { LicenseManager } from 'ag-grid-enterprise'
LicenseManager.setLicenseKey(process.env.VUE_APP_AG_GRID_KEY)
import mixin from '@/utils/mixin'

import elDragDialog from '@/directive/el-dragDialog' // base on element-ui
import permission from '@/directive/permission' // 权限判断指令
import uppercase from '@/directive/uppercase' // 权限判断指令
import loadmore from '@/directive/loadmore' // 用户解决el-table大数据卡顿问题的指令
import stopNumberMousewheel from '@/directive/stopNumberMousewheel'
import checkPermission from '@/utils/permission'
import { permissionJump } from '@/utils/router'
import { constantI18n } from '@/utils/selectData'
import { selectByLang, getLangColumn } from '@/utils/langUtil'

import cargoSvgIcon from '@/components/Cargo/Common/cargoSvgIcon'
import cargoLimitedSelect from '@/components/Cargo/Common/cargoLimitedSelect'
import CharCount from '@/components/Cargo/Common/CharCount'
import cargoPagination from '@/components/Pagination' // Secondary package based on el-pagination
import cargoAgGrid from '@/components/Cargo/Common/cargoAgGrid' // Secondary package based on el-pagination
import cargoGridStateBtn from '@/components/Cargo/Common/cargoGridStateBtn' // Secondary package based on el-pagination
import agGridColumnEdit from '@/components/Cargo/grid/agGridColumnEdit' // agGrid列编辑组件
import agGridColumnEditGroup from '@/components/Cargo/grid/agGridColumnEditGroup' // agGrid（多输入框）列编辑组件
import CargoDateTimePicker from '@/components/Cargo/Common/CargoDateTimePicker' // 覆盖el-date-picker
import CargoElInput from '@/components/Cargo/Common/cargoElInput' // 覆盖el-input
import CargoElInputNumber from '@/components/Cargo/Common/cargoElInputNumber' // 覆盖el-input-number
import CargoElSelect from '@/components/Cargo/Common/cargoElSelect' // 覆盖el-select
import CargoTooltip from '@/components/Cargo/Common/CargoTooltip' // 覆盖el-select
import CargoElUpload from '@/components/Cargo/Common/cargoElUpload' // 覆盖el-upload
import columnNumberDisplayAndInput from '@/components/Cargo/Common/columnNumberDisplayAndInput' // agGrid列编辑组件
import LineLabel from '@/components/Cargo/Common/LineLabel'
import * as filters from './filters' // global filters
import IconDocumentCopy from '@/components/Cargo/grid/iconDocumentCopy'

import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import '@wangeditor/editor/dist/css/style.css'
import GlobalDialog from '@/components/Cargo/Job/GlobalDialog.vue'
import microApp from '@micro-zoe/micro-app'
import requestMirco from '@/utils/request' // 子应用可以使用主应用的request
import { reportRouteChange } from '@/utils/observability'

Vue.use(Element, {
  size: Cookies.get('size') || 'mini', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})

// 微应用,配置fetch是为了使子应用可以获取到cookie
microApp.start({
  fetch(url, options, appName) {
    const config = {
      // fetch 默认不带cookie，如果需要添加cookie需要配置credentials
      credentials: 'include' // 请求时带上cookie
    }

    return window.fetch(url, Object.assign(options, config)).then((res) => {
      return res.text()
    })
  }
})

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.use(elDragDialog)
Vue.use(permission)
Vue.use(uppercase)
Vue.use(loadmore)
Vue.use(stopNumberMousewheel)
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
Element.MessageBox.setDefaults({
  closeOnClickModal: false
})
Vue.component('cargo-svg-icon', cargoSvgIcon)
Vue.component('CharCount', CharCount)
Vue.component('cargo-limited-select', cargoLimitedSelect)
Vue.component('cargo-pagination', cargoPagination)
Vue.component('cargo-ag-grid', cargoAgGrid)
Vue.component('cargo-grid-state-btn', cargoGridStateBtn)
Vue.component('agGridColumnEdit', agGridColumnEdit)
Vue.component('agGridColumnEditGroup', agGridColumnEditGroup)
Vue.component('agGridColumnEditGroup', agGridColumnEditGroup)
Vue.component('el-date-picker', CargoDateTimePicker)
Vue.component('el-input', CargoElInput)
Vue.component('el-input-number', CargoElInputNumber)
Vue.component('el-select', CargoElSelect)
Vue.component('el-tooltip', CargoTooltip)
Vue.component('el-upload', CargoElUpload)
Vue.component('iconDocumentCopy', IconDocumentCopy)
Vue.component('columnNumberDisplayAndInput', columnNumberDisplayAndInput)
Vue.component('line-label', LineLabel)
Vue.component('GlobalDialog', GlobalDialog)

Vue.prototype.$numeral = numeral
Vue.prototype.$moment = moment
Vue.prototype.$checkPermission = checkPermission
Vue.prototype.$constantI18n = (key) => { return constantI18n(i18n, key) }
Vue.prototype.$permissionJump = permissionJump
Vue.prototype.$message = Message
Vue.prototype.$selectByLang = selectByLang
Vue.prototype.$getLangColumn = getLangColumn
Vue.prototype.$globalDialog = new Vue(GlobalDialog).$mount()

Vue.config.productionTip = false

Vue.mixin(mixin)
document.body.appendChild(Vue.prototype.$globalDialog.$el)
router.afterEach(to => reportRouteChange(to))
const fatherVue = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})

// 将主应用的Vue的store、i18n、requestMirco暴露给子应用
window.__MAIN_APP__ = {
  store: fatherVue.$store,
  i18n: fatherVue.$i18n,
  requestMirco: requestMirco
}
